module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("Uej7S"))).then(() => parcelRequire('5erN3'));